<template>
	<v-container id="regular-tables-view" fluid tag="section">
		<material-card icon="mdi-flower-tulip" icon-small title="لیست درخواست وام ها" color="accent">
			<template #topActions>
				<div class="d-flex justify-end">

					<v-btn color="secondary " dark class="mx-1" @click="add">
						<v-icon dark left>
							mdi-plus-circle-outline
						</v-icon>
						ثبت درخواست جدید
					</v-btn>
				</div>
			</template>
			<div class="pa-5 pt-0">
				<v-row>
					<v-col cols="12" md="3">
					</v-col>
					<v-col cols="12" md="6">
						<date-navigator v-model="dateRange" :options="{ rangeMode: true }">
							<div class="text-center">
								<v-btn color="primary" dark small class="mx-1" @click="loadData">
									دریافت اطلاعات
								</v-btn>
							</div>
						</date-navigator>
					</v-col>
					<v-col cols="12" md="3" class="d-flex align-center justify-end">
						<export-excel :items="items" :headers="headers" :fileName="excelFileName">
						</export-excel>
					</v-col>
				</v-row>
				<v-row>
					<v-col cols="12" v-if="statuses.length">
						<span class="ml-2">فیلترها: </span>
						<v-btn-toggle multiple v-model="statusFilter" dense tile outlined color="purple" class="mr-2 flex-wrap">
							<v-btn v-for="status in statuses" :key="status" :value="status" small>
								{{ status }}
								<v-badge color="blue" :content="items.filter(x => x.str_Status == status).length || '0'" inline>
								</v-badge>
							</v-btn>
						</v-btn-toggle>
					</v-col>
					<v-col cols="12" md="6">
						<v-text-field v-model="search" append-icon="mdi-magnify" label="اطلاعات مورد نظر خود جهت جستجو وارد کنید" single-line hide-details class="mb-5" />
					</v-col>
					<v-col cols="12">
						<v-data-table :height="dataTableFixedHeight - 100" fixed-header :loading="loading" :headers="headers" :items="filteredItems" :footer-props="{ 'items-per-page-options': [5, 15, 50, 100] }" :items-per-page="50" :search="search" class="elevation-1">
							<template v-slot:item="row">
								<tr>
									<td class="text-center">
										<div class="text-center">
											شماره درخواست: {{ row.item.code }}
										</div>
										<div class="my-1"><small>{{ row.item.loanModel.title }}</small></div>
										<div class="text-center">
											<v-btn class="mx-1" x-small color="secondary" @click="edit(row.item)">
												مشاهده
											</v-btn>
										</div>
									</td>
									<td>
										<div>{{ row.item.memberModel.fullName }}</div>
										<div class="grey--text">{{ row.item.memberModel.nationalCode }}</div>
									</td>
									<td class="text-center">
										{{ row.item.amount.toString().toPriceFormat() }}
									</td>
									<td class="text-center ltr">
										{{ `${row.item.requestDate_Persian.date} ${row.item.requestDate_Persian.time}` }}
									</td>
									<td class="text-center">
										{{ row.item.str_AgentStatus }}
									</td>
									<td class="text-center">
										{{ row.item.str_ChargeType }}
									</td>
									<td class="text-center">
										<div>{{ row.item.userLoan ? row.item.userLoan.loanModel.title : '' }}</div>
										<div v-if="row.item.userLoan" class="grey--text">شماره وام: {{ row.item.userLoan ?
											row.item.userLoan.code : '' }}</div>
									</td>
									<td class="text-center">
										<div v-if="hasParentAgent">
											<div>
												{{ row.item.userLoan ? row.item.userLoan.subAgentPrice.toString().toPriceFormat() : '' }}
											</div>
											<div class="grey--text">
												{{ row.item.userLoan && row.item.userLoan.subAgentDueDate_Persian.year !== 0 ?
													row.item.userLoan.subAgentDueDate_Persian.date : '' }}
											</div>
										</div>
										<div v-else>
											<div>
												{{ row.item.userLoan ? row.item.userLoan.agentPrice.toString().toPriceFormat() : '' }}
											</div>
											<div class="grey--text">
												{{ row.item.userLoan && row.item.userLoan.agentDueDate_Persian.year !== 0 ?
													row.item.userLoan.agentDueDate_Persian.date : '' }}
											</div>
										</div>

									</td>
									<td class="text-center">
										<div v-if="hasParentAgent">
											{{ row.item.userLoan ? row.item.userLoan.sumParentAgentPayments.toString().toPriceFormat() : '' }}
										</div>
										<div v-else>
											{{ row.item.userLoan ? row.item.userLoan.sumSponsorPayments.toString().toPriceFormat() : '' }}
										</div>
									</td>
									<td>
										{{ row.item.adminDescription || "-" }}
									</td>
									<td class="text-center">
										<v-btn class="mx-1" fab dark small color="secondary" @click="edit(row.item)">
											<v-icon dark>
												mdi-square-edit-outline
											</v-icon>
										</v-btn>
										<v-btn class="mx-1" fab dark small color="pink" @click="remove(row.item)">
											<v-icon dark>
												mdi-trash-can-outline
											</v-icon>
										</v-btn>
									</td>
								</tr>
							</template>
						</v-data-table>
					</v-col>
				</v-row>
			</div>

			<v-dialog v-model="dialog" scrollable persistent max-width="1100px">
				<v-card>
					<v-card-title>
						<span class="headline">مشخصات درخواست وام</span>
						<v-spacer />
						<v-btn @click="dialog = false" icon>
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</v-card-title>
					<v-card-text>
						<v-container fluid>
							<modify-request ref="modifyRequest" v-if="dialog" :data="selectedRequest" :user="selectedRequest.memberModel" @callbck="callbck" />
						</v-container>
					</v-card-text>
				</v-card>
			</v-dialog>

			<v-dialog v-model="dialogCustomer" scrollable persistent max-width="700px">
				<v-card>
					<v-card-title>
						<span class="headline">مشخصات مشتری</span>
						<v-spacer />
						<v-btn @click="dialogCustomer = false" icon>
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</v-card-title>
					<v-card-text>
						<v-container>
							<modify-customer :data="selectedCustomer" v-if="dialogCustomer" @callbck="customer_callbck" :fromLoanRequest="true" />
						</v-container>
					</v-card-text>

				</v-card>
			</v-dialog>

		</material-card>
		<confirm-dlg ref="confirm" />
		<div class="py-3" />
	</v-container>
</template>

<script>
	import { get } from 'vuex-pathify'
	import api from '@/util/app-api'
	import toast from '@/util/toast'
	import { emptyId } from '@/util/emptyId'

	export default {
		name: 'AdminLoanRequestsView',
		components: {
			ConfirmDlg: () => import('@/components/Confirm'),
			'modify-customer': () => import('./ModifyCustomer'),
			'modify-request': () => import('./ModifyLoanRequest.vue'),
		},
		data() {
			return {
				errorMessages: '',
				localData: {},
				selectedRequest: {},
				selectedCustomer: {},
				dialog: false,
				dialogCustomer: false,
				search: '',
				dateRange: { start: new Date(new Date().setMonth(new Date().getMonth() - 1)).toJSON(), end: '' },
				headers: [
					{
						text: 'اطلاعات درخواست',
						align: 'start',
						sortable: true,
						value: 'code',
						width: 200
					}, {
						text: 'نام مشتری',
						align: 'start',
						sortable: true,
						value: 'memberModel.fullName',
						width: 150
					},
					{
						text: 'وام درخواستی',
						align: 'start d-none',
						sortable: true,
						value: 'loanModel.title',
					},
					{
						text: 'مبلغ',
						align: 'center',
						sortable: true,
						value: 'amount',
					},
					{
						text: 'تاریخ ثبت درخواست',
						align: 'center',
						sortable: true,
						value: 'requestDate_Persian',
					},
					{
						text: 'وضعیت درخواست',
						align: 'center',
						sortable: true,
						value: 'str_AgentStatus',
					},
					{
						text: 'نحوه دریافت',
						align: 'center',
						sortable: true,
						value: 'str_ChargeType',
					},
					{
						text: 'وام مرتبط',
						align: 'center',
						sortable: true,
						value: 'userLoan.code',
						width: 150
					},
					{
						text: 'سررسید تسویه نماینده',
						align: 'center',
						sortable: true,
						value: 'userLoan.agentDueDate_Persian',
					},
					{
						text: 'واریزی اسپانسر',
						align: 'center',
						sortable: true,
						value: 'userLoan.sumSponsorPayments',
					},
					{
						text: 'نظر کارشناس',
						align: 'start',
						sortable: true,
						value: 'adminDescription',
						width: 200
					},
					{
						text: 'عملیات ها',
						align: 'center',
						sortable: false,
						width: 150,
					},
				],
				items: [],
				statuses: [],
				statusFilter: [],
				loading: false
			}
		},
		mounted() {
			this.loadData()
		},
		computed: {
			excelFileName() {
				let name = 'گزارش درخواست وام ها'
				if (this.dateRange.start)
					name += ' از ' + this.dateRange.start.toString().split('T')[0]
				if (this.dateRange.end)
					name += ' تا ' + this.dateRange.end.toString().split('T')[0]
				name += '.xls'
				return name
			},
			filteredItems() {
				if (!(this.statusFilter || []).length)
					return this.items
				let clonedItems = []
				clonedItems.push(...this.items)
				clonedItems = clonedItems.filter(x => this.statusFilter.indexOf(x.str_Status) > -1)
				return clonedItems
			},
			...get('auth', [
				'getCurrentUser',
			]),
			hasParentAgent() {
				var user = this.getCurrentUser
				return !!user?.userData?.agentId
			}
		},
		methods: {
			loadData() {
				this.loading = true
				api.get('agent/userLoanRequest/list?start=' + this.dateRange.start + '&end=' + this.dateRange.end, null)
					.then(response => {
						this.items = response
						this.statuses = [...new Set(response.map(x => x.str_Status))]
					})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(() => {
						this.loading = false
					})
			},
			add() {
				this.dialogCustomer = true
				this.selectedCustomer = { id: 0 }
			},
			edit(item) {
				this.dialog = true
				this.selectedRequest = item
			},
			callbck(result) {
				if (result === 'close') {
					this.dialog = false
					return
				}
				if (result) {
					this.loadData()
				}
			},
			customer_callbck(result) {
				this.dialogCustomer = false
				if (result)
					this.loadData(true)
			},
			async remove(item) {
				if (!item) {
					return
				}

				if (
					await this.$refs.confirm.open(
						'توجه',
						'آیا از حذف این آیتم مطمئن هستید؟',
					)
				) {
					api
						.post('agent/userLoanRequest/delete/' + item.id)
						.then(response => {
							toast.success('اطلاعات با موفقیت حذف شد.')
							this.loadData()
						})
						.catch(err => {
							toast.error(err.message)
						})
				}
			},
		},
	}
</script>
<style></style>
